import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const PaymentFailure = () => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [location, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center relative">
        {/* Failure Icon */}
        <i className="fa-solid fa-circle-xmark text-red-500 text-6xl"></i>

        {/* Heading */}
        <h2 className="text-2xl font-bold text-gray-800 mt-4">
          Payment Failed!
        </h2>

        {/* Message */}
        <p className="text-gray-600 mt-2">
          Oops! Something went wrong. Your payment could not be processed.
        </p>

        {/* Countdown Text */}
        <p className="text-gray-500 mt-4 text-sm">
          Redirecting in <span className="font-bold">{countdown}</span>{' '}
          seconds...
        </p>

        {/* Progress Bar */}
        <div className="absolute bottom-0 left-0 w-full h-2 bg-gray-300 rounded-b-lg">
          <div
            className="h-2 bg-red-500 transition-all duration-1000 ease-linear"
            style={{width: `${(5 - countdown) * 20}%`}} // Fills up in 5 sec
          ></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
